import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Loader from "../components/Loader";
import appConfig from "../../config/appConfig";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import { AUTH_TOKEN } from "../../constants/token";

const IFRAME_STYLE = {
  width: "100%",
  height: "calc(100vh - 180px)",
  minHeight: "500px",
  border: 0,
};

const AssistanceMatrix = () => {
  const { t, ready } = useTranslation();

  document.title =
    "Satis client - " + (ready ? t("Matrice d'assistance") : "");

  const [load, setLoad] = useState(true);
  const [htmlContent, setHtmlContent] = useState(null);
  const [error, setError] = useState(null);

  const fetchCustomGuide = useCallback(async () => {
    if (!verifyTokenExpire()) {
      setHtmlContent(null);
      setError(t("Session expirée. Veuillez vous reconnecter."));
      setLoad(false);
      return;
    }

    setLoad(true);
    setError(null);
    axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;

    try {
      const { data } = await axios.get(
        `${appConfig.apiDomaine}/api/custom-guide`,
        { responseType: "text" }
      );

      const html = typeof data === "string" ? data.trim() : "";

      if (!html) {
        setHtmlContent(null);
        setError(t("Réponse invalide : contenu du guide introuvable."));
        return;
      }

      setHtmlContent(html);
    } catch (err) {
      console.error(err);
      setHtmlContent(null);
      setError(t("Impossible de charger la matrice d'assistance."));
    } finally {
      setLoad(false);
    }
  }, [t]);

  useEffect(() => {
    fetchCustomGuide();
  }, [fetchCustomGuide]);

  if (!ready) return null;

  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container kt-container--fluid">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">
              {t("Matrice d'assistance")}
            </h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <a href="#icone" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter" />
              </a>
              <span className="kt-subheader__breadcrumbs-separator" />
              <a
                href="#button"
                onClick={(e) => e.preventDefault()}
                className="kt-subheader__breadcrumbs-link"
              >
                {t("Matrice d'assistance")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        {load ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "400px" }}
          >
            <Loader />
          </div>
        ) : error ? (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        ) : (
          <iframe
            title={t("Matrice d'assistance")}
            srcDoc={htmlContent}
            style={IFRAME_STYLE}
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        )}
      </div>
    </div>
  );
};

export default AssistanceMatrix;
